import { addDays, addYears } from 'date-fns';
import { KEYBOARD } from 'modules/constants';
import { wrapEvent } from 'modules/utils';
import { YEARS_PER_ROW } from '../styled';
export function getNavigationDistance(params) {
    const { key, yearPickerVisible } = params;
    switch (key) {
        case KEYBOARD.ARROW_LEFT:
            return -1;
        case KEYBOARD.ARROW_RIGHT:
            return 1;
        case KEYBOARD.ARROW_UP:
            return yearPickerVisible ? -YEARS_PER_ROW : -7;
        case KEYBOARD.ARROW_DOWN:
            return yearPickerVisible ? YEARS_PER_ROW : 7;
        default:
            return undefined;
    }
}
export function useKeyboardNavigation(props) {
    const { onKeyDown, focusedDate, setFocusedDate, focusedYear, setFocusedYear, yearPickerVisible } = props;
    const navigateDays = (days) => setFocusedDate(addDays(focusedDate, days));
    const navigateYears = (years) => setFocusedYear(addYears(focusedYear, years));
    const navigateFunction = yearPickerVisible ? navigateYears : navigateDays;
    const handleKeyDown = wrapEvent(onKeyDown, (event) => {
        const { key } = event;
        const preventScroll = () => event.preventDefault();
        const navigationDistance = getNavigationDistance({ key, yearPickerVisible });
        if (navigationDistance) {
            preventScroll();
            event.stopPropagation();
            navigateFunction(navigationDistance);
        }
    });
    return { handleKeyDown };
}
